export default "__VITE_ASSET__BHDJmpG3__"